module.exports = __webpack_public_path__ + "img/application-analysis.14faf76a.svg";